import graphql from "babel-plugin-relay/macro";

export const QUERY_FRAGMENT = graphql`
	fragment groupRulesTab_QueryFragment on AccountGroupAssignmentRule @inline {
		id
	}
`;
